import React from 'react'
import { Checkbox } from 'components/Form'
import { Col, Row } from 'components/Grid'
import { FastField } from 'formik'

export const OPTIONS_FOR_ADS = [
  { name: 'businessType', prettyName: 'Venda' },
  { name: 'businessType', prettyName: 'Locação' },
]

export const OPTIONS_FOR_VALUATED = [
  { name: 'valuatedType', prettyName: 'Leilão' },
  { name: 'valuatedType', prettyName: 'Terceiros', disabled: true },
  { name: 'valuatedType', prettyName: 'EEmovel', disabled: true },
]

export const renderMicro = (elements, props, values, mobile = false) =>
  elements.map(({ name, prettyName, disabled = false }) => {
    const checked = values[name] === prettyName
    return (
      <Row
        between="xs"
        key={prettyName}
        className="FilterCategory__OptionContainer__SubOption"
      >
        <Col>
          <FastField
            component={Checkbox}
            name={name}
            disabled={disabled}
            mobileSub={mobile}
            label={prettyName}
            checked={checked}
            onChange={() =>
              props.setFieldValue(name, checked ? '' : prettyName)
            }
          />
        </Col>
      </Row>
    )
  })

export const renderMacro = (name, label) => (
  <Row between="xs">
    <Col>
      <p name={name}>{label}</p>
    </Col>
  </Row>
)
